module.exports = __webpack_public_path__ + "static/media/assistance_type_tire.e61eca1f.svg";